export default {
  getWineOfMonthCampaigns: (state, getters, rootState, rootGetters) => (type = 'wine-of-month') => {
    const campaigns = state.campaigns.filter(({ type: t, active }) => t === type && active)
    let cArr = []
    for (const campaign of campaigns) {
      const c = { ...campaign }
      if (campaign.wineId) {
        c.wine = rootGetters['wine/getWineById'](campaign.wineId)
      }
      if (campaign.wineIds) {
        if (!c.wines) c.wines = []
        for (const id of campaign.wineIds) {
          c.wines.push(rootGetters['wine/getWineById'](id))
        }
      }
      cArr.push(c)
    }
    cArr = cArr.reverse()
    return cArr.length < 10 ? cArr : cArr.slice(0, 12)
  },
  getCampaignById: (state, getters, rootState, rootGetters) => id => {
    const campaign = state.campaigns.find(campaign => campaign.id === id)
    const c = { ...campaign }
    if (campaign.wineId) {
      c.wine = rootGetters['wine/getWineById'](campaign.wineId)
    }
    if (campaign.wineIds) {
      if (!c.wines) c.wines = []
      for (const id of campaign.wineIds) {
        c.wines.push(rootGetters['wine/getWineById'](id))
      }
    }
    return c
  },
  getCampaignBySlugAndType: (state, getters, rootState, rootGetters) => (slug, type) => {
    const campaign = state.campaigns.find(campaign => campaign.slug === slug && campaign.type === type)
    if (!campaign) return undefined
    campaign.wine = rootGetters['wine/getWineById'](campaign.wineId)
    return campaign
  },
}
